



































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as ui from '../../ui';
import T from '../../lang';
import { reportAnIssueURL } from '../../errors';
import { getBlogUrl } from '../../urlHelper';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
  faFacebook,
  faGithub,
  faDiscord,
} from '@fortawesome/free-brands-svg-icons';
library.add(faFacebook, faGithub, faDiscord);

@Component({
  components: {
    FontAwesomeIcon,
  },
})
export default class Footer extends Vue {
  @Prop() isLoggedIn!: boolean;
  @Prop() omegaUpLockDown!: boolean;

  T = T;
  ui = ui;
  reportAnIssueURL = reportAnIssueURL;

  get OmegaUpBlogURL(): string {
    // Use the key defined in blog-links-config.json
    return getBlogUrl('OmegaUpBlogURL');
  }

  get PrivacyPolicyURL(): string {
    return getBlogUrl('PrivacyPolicyURL');
  }

  get CodeofConductPolicyURL(): string {
    return getBlogUrl('CodeofConductPolicyURL');
  }
}
